document.addEventListener("DOMContentLoaded", (event) => { //ensure ready for GSAP
  const images = document.querySelectorAll('#ftd-gardens .ftd-gallery img');
  const content = document.querySelectorAll('#ftd-gardens .text .ftd');
  const position_dots = document.querySelectorAll('#ftd-gardens .dots .dot');
  const position_current  = document.querySelector('#ftd-gardens .position .current');
  const position_total = document.querySelector('#ftd-gardens .position .total');
	const n = images.length;
	const tl = gsap.timeline({ repeat: -1, repeatDelay: 0 }); //create timeline

	position_total.innerHTML = n;
  gsap.set([images[n - 1], content[n - 1]], { autoAlpha: 1, zIndex: 1 });  // make last item visible to start
  
  for (let i = 0; i < n; i++) { //timeline actions for each image
    const prev = (i - 1 + n) % n;
    tl.set([images[i], content[i]], { zIndex: 2 }); // current image to front before fading in
    tl.call(() => {
    	position_current.innerHTML = i + 1;
    	position_dots.forEach(function (dot, index) {dot.classList.remove("active");});
    	position_dots[i].classList.add("active");
    });
    tl.to([images[i], content[i]], { autoAlpha: 1, duration: 1, ease: "none" }, "+=0");
    tl.to([images[prev], content[prev]], { autoAlpha: 0, duration: 1, ease: "none" }, "<");
    tl.set([images[prev], content[prev]], { zIndex: 0 }); // send the faded-out image to back
    tl.to({}, { duration: 3 });
  }

  position_dots.forEach((dot, index) => {
	  dot.addEventListener("click", () => {
	    const segmentDuration = tl.duration() / n; //get timeline animation length for single image
	    tl.seek(segmentDuration * index, false);  // jump to position:
	  });
	});

});